import React, { useCallback, useMemo, useState } from "react";
import useStyles from 'isomorphic-style-loader/useStyles'
import classes from './style.module.scss'
import { Iconfont } from "../../../../../../../components/icon/iconfont";
import { FormattedMessage } from "react-intl";
import DisplayTransition from "../../../../../../components/transitions/display-transition";
import BlackMask from "../../../../../../components/mask/index";
import { useEffect } from "react";
import ProductNormalSize from "./normal-size/index";
import { useDispatch, useSelector } from "react-redux";
import { SET_SIZE_CHART } from "../../../../../../../../store/actions/global";
import SizeCountrySelector from "../../../../../components/size-country-selector";
import SizeCollectionSelector from "../size-collection-selector";
import QuickShippingTip from "../quick-shipping";

const SizeChartModal = props =>{
    const { show, onClose, productId } = props;

    return <React.Fragment>
            <DisplayTransition in={show} className={classes.SizeChartModal}>
                <div>
                    <div className={classes.Hd}>
                        <FormattedMessage id="size_chart" defaultMessage="Size Chart" />
                        <Iconfont className={classes.CloseIcon} onClick={onClose}>&#xe7c9;</Iconfont>
                    </div>

                    <div className={classes.Bd}>
                        <iframe 
                            width={"100%"} 
                            height={"100%"}
                            seamless 
                            scrolling={"no"}
                            src={`/fs/sizechart-pc?productId=${productId}&isRemove=1`}
                            border={0}
                        ></iframe>
                    </div>
                </div>
        </DisplayTransition>

        {
            show && <BlackMask onClick={onClose} />
        }
    </React.Fragment>
    
}

//产品类型，0：衣服，1：鞋子，2：美妆，3：小饰品
const ProductSizeInformation = props =>{
    useStyles(classes);
    const { productHooks } = props;
    const { 
        selectedProduct,
        productVO
    } = productHooks;

    const dispatch = useDispatch()
    const [showSizeChart,setShowSizeChartLocal] = useState(false);

    const global = useSelector(state => state.global)
    const isOv = v => v?.domesticDelivery.enabled;

    const overseaSizeList = useMemo(() => {
        const getSizeLabel = size => {
            const countries = selectedProduct?.sizeChart2?.countryAndSizesList?.[0]?.map(c => c.country)
            const sizeDefaultCountry = countries?.find(c => c === global?.sizeDefaultCountry) || selectedProduct?.sizeChart2?.defaultCountry
            const sizes = selectedProduct?.sizeChart2?.countryAndSizesList?.find?.(s => s[0]?.size === size)
            if(sizes?.length > 0){
                return sizes?.find(s => s.country === sizeDefaultCountry)?.size || size
            }
            return size
        }
        let overseaV = selectedProduct?.variants?.map(v => isOv(v)? v: '')
        const overseaSize = overseaV?.filter(o => !!o)?.map(o => getSizeLabel(o?.size))
        return overseaSize
    }, [global, selectedProduct])

    useEffect(async () =>{
        if(selectedProduct?.variants?.length > 1 && selectedProduct?.sizeChart2 && productVO?.taglia){
            setShowSizeChartLocal(true);
        }
    },[]);

    const openSizeChart = () => {
        dispatch({
            type:SET_SIZE_CHART,
            payload:{
                show: true,
                data: {
                    selectedProduct:selectedProduct,
                    products: productVO?.products,
                    taglia: productVO?.taglia,
                    productSizeData: productVO?.productSizeData
                }
            }
        })
    }

    return <div className={classes.ProductSizeInformation}>
        <div className={classes.Title}>
            {
                selectedProduct?.sizeChart2 ?
                <SizeCountrySelector sizeChart2={selectedProduct?.sizeChart2}/>:
                <span><FormattedMessage id="size" defaultMessage={'Size'}/>:</span>
            }

            {
                showSizeChart && <span className={classes.SizeChart} onClick={()=>openSizeChart(true)}>
                    <Iconfont>&#xe6bc;</Iconfont>
                    <span><FormattedMessage id="size_guide" defaultMessage="Size Guide" />?</span>
                </span>
            }
        </div>

        <ProductNormalSize productHooks={productHooks} />

        {
            // 海外仓子产品提示 quick shipping
            overseaSizeList?.length > 0 &&
            <QuickShippingTip overseaSizeList={overseaSizeList}/>
        }

        {
            (selectedProduct?.sizeChart2?.id == 2 || selectedProduct?.sizeChart2?.id == 1) && !selectedProduct?.hasDoubleSize && <SizeCollectionSelector productId={selectedProduct.id} product={selectedProduct} />
        }
        {/* <SizeChartModal show={show} onClose={()=>setShow(false)} productId={selectedProduct?.id} /> */}
    </div>
}

export default ProductSizeInformation;